import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { BaseCampoComEditComponent } from "../base-campo-com-edit/base-campo-com-edit.component";

@Component({
  selector: "app-campo-porc-index",
  templateUrl: "./campo-porc-index.component.html",
  styleUrls: ["../base-campo-com-edit/base-campo-com-edit.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: BaseCampoComEditComponent,
      useExisting: CampoPorcIndexComponent,
    },
  ],
})
export class CampoPorcIndexComponent
  extends BaseCampoComEditComponent
  implements OnInit {
  ngOnInit() {
    this.nome = "% Index";
  }
}
